/* This file was generated automatically. Do not edit manually. */

export enum PortfolioPromotions {
    BeforeCheckIn = 'BeforeCheckIn',
    AfterCheckIn = 'AfterCheckIn',
    DuringStay = 'DuringStay',
    BeforeCheckOut = 'BeforeCheckOut',
    AfterCheckOut = 'AfterCheckOut',
    DuringCheckOut = 'DuringCheckOut',
}
